var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"std-status-text",class:[_vm.type ? `has-dot std-status-text--${_vm.type}` : '']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }